import { LoadingState } from "@cmde/shadcn";
import { useTranslation } from "react-i18next";

export function LoadingSeasonsList() {
  const { t } = useTranslation();

  return (
    <LoadingState
      title={t("seasons.list.general.loading_seasons")}
      description={t("seasons.list.general.please_wait_while_we_load_the_seasons_for_you")}
    />
  );
}
